export const environment = {
  production: true,
  env: 'v1',
  url: 'https://zksync.zomma.pro/',
  apiUrl: 'https://api-v1.zomma.pro/',
  wsUrl: 'wss://api-v1.zomma.pro/cable',
  tasks: {
    twitterTaskId: 1,
    discordTaskId: 2
  },
  features: {
    faucet: false,
    blackScholesLookup: false,
    apiSpot: true,
    signedData: true,
    multiTrade: false,
    ivAdjust: false,
    checkCountry: true
  },
  paymasters: [
    {
      name: 'Zomma Protocol',
      type: 'normal',
      address: '0x622504339847230119201a0d53571899c70b4a19',
      tokens: [
        {
          name: 'USDC.e',
          address: '0x3355df6d4c9c3035724fd0e3914de96a5a83aaf4',
          decimal: 6,
          priceMethod: 'eth',
          precision: 2,
          icon: '/retired-zksync/assets/images/icons/asset_USDC_24.svg',
          discount: 0
        }
      ]
    },
    {
      name: 'Holdstation',
      type: 'holdstation',
      address: '0x069246dFEcb95A6409180b52C071003537B23c27',
      tokens: [
        // {
        //   name: 'USDC',
        //   address: '0x3355df6d4c9c3035724fd0e3914de96a5a83aaf4',
        //   decimal: 6,
        //   priceMethod: 'none',
        //   precision: 2,
        //   icon: '/assets/images/icons/asset_USDC_24.svg'
        // },
        {
          name: 'HOLD',
          address: '0xed4040fd47629e7c8fbb7da76bb50b3e7695f0f2',
          decimal: 18,
          priceMethod: 'none',
          precision: 4,
          icon: '/retired-zksync/assets/images/icons/asset_hold_32.svg',
          discount: 50
        },
        {
          name: 'ZK',
          address: '0x5a7d6b2f92c77fad6ccabd7ee0624e64907eaf3e',
          decimal: 18,
          priceMethod: 'none',
          precision: 4,
          icon: '/retired-zksync/assets/images/icons/asset_zksync_32.svg',
          discount: 20
        },
        {
          name: 'USDT',
          address: '0x493257fd37edb34451f62edf8d2a0c418852ba4c',
          decimal: 6,
          priceMethod: 'none',
          precision: 2,
          icon: '/retired-zksync/assets/images/icons/asset_usdt_32.svg',
          discount: 20
        }
      ]
    }
  ],
  retired: {
    vaults: [
      {
        address: '0x709051774c60c0527dbaf880f41425eae036efaf',
        name: 'Trade Account'
      }
    ],
    pools: [
      {
        address: '0x96249501e1770e83c81dbf276c74fd8e16dc9d30',
        name: 'Conservative Pool'
      },
      {
        address: '0x5b28bc13a4937b33987d2079a80f123c2dd80267',
        name: 'Stable Pool'
      }
    ]
  },
  betaRetired: {
    vaults: [
      {
        address: '0x7bf1f1c2d8caa200b068747487cb9bf109e529f1',
        name: 'Trade Account'
      }
    ],
    pools: [
      {
        address: '0xef1f700308566a286e05957ea90e3e20eaf669d6',
        name: 'Conservative Pool'
      },
      {
        address: '0x7efbdef114c79c36c21e12412d0fc9a383927fb3',
        name: 'Stable Pool'
      }
    ]
  },
  v1Retired: {
    vaults: [
      {
        address: '0x1f14544aea89046e068e98c8672d2fbc3ab45bab',
        name: 'BTC-USDC Trade Account'
      },
      {
        address: '0xdd5ae451a75a654146747235fdb515f06a55d018',
        name: 'ETH-USDC Trade Account'
      }
    ],
    pools: [
      {
        address: '0xebb31220bd19d7a3acd8396c344133c276760397',
        name: 'BTC-USDC Conservative Pool'
      },
      {
        address: '0xf34da9505c661b42c3d4cf877e39e9e199957915',
        name: 'BTC-USDC Stable Pool'
      },
      {
        address: '0x6d78a29ac2dfeeaa40d1ac70cc99b42686b0d8b7',
        name: 'ETH-USDC Conservative Pool'
      },
      {
        address: '0xa9f371e985f9b686c7f607ea30568348e72cbde6',
        name: 'ETH-USDC Stable Pool'
      }
    ],
    tradingVaults: [
      {
        address: '0xd84e4a559628bd45a84b4b09c8039e485f462a7b',
        name: 'BTC-USDC Put Selling'
      },
      {
        address: '0xd39e8043fd9b1cce339df72344ddb745c185784a',
        name: 'ETH-USDC Put Selling'
      }
    ]
  },
  networks: [
    {
      name: 'zkSync Era',
      icon: '/retired-zksync/assets/images/icons/asset_zksync_24.svg',
      faucet: false,
      contracts: {
        bridgeReceiver: '0x0e3a797ef3e124cb5880b6a9b37bd56f048fe503',
        zommaBridgeReceiver: '0x2229040118c7a506241a0712a63ababc26229e70',
        rewardDistributor: '0x306b553ef0132e31db410622595781cfe6cd6430',
        optionPricer: '0x7fd526712bdfc4ee2b89d945e0a513536ec8551b'
      },
      bridgeChainId: 165,
      params: {
        chainId: '0x144',
        chainName: 'zkSync Era',
        nativeCurrency: {
          name: 'ETH',
          symbol: 'ETH',
          decimals: 18
        },
        rpcUrls: ['https://mainnet.era.zksync.io'],
        blockExplorerUrls: ['https://explorer.zksync.io/']
      }
    },
    {
      name: 'Arbitrum',
      icon: '/retired-zksync/assets/images/icons/asset_arbitrum_20.svg',
      faucet: false,
      bridge: {
        usdc: '0xaf88d065e77c8cC2239327C5EDb3A432268e5831',
        zomma: {
          sender: '0xd6706520ead142e044cbf7f323b4c1d62942cb47'
        },
        layerzero: {
          endpoint: '0x3c2269811836af69497E5F486A85D7316753cf62',
          sender: '0xc1d8ef8fbbc611805e66c5ed02b1373c065f4846'
        }
      },
      params: {
        chainId: '0xa4b1',
        chainName: 'Arbitrum',
        nativeCurrency: {
          name: 'ETH',
          symbol: 'ETH',
          decimals: 18
        },
        rpcUrls: ['https://arb1.arbitrum.io/rpc'],
        blockExplorerUrls: ['https://arbiscan.io/']
      }
    }
  ]
};
